import React from "react";
import useAuth from "../../hooks/useAuth";
import CampaignMIS from "./CampaignMIS";

const ManageCampaignMIS = () => {
    const { user } = useAuth();
    return <>{user && <CampaignMIS />}</>;
};

export default ManageCampaignMIS;
